import React from "react"
import PropTypes from "prop-types";
import Tr from "translations/Translations";
import Select, {createSelectItem} from "components/Select";
import {makeStyles} from "@material-ui/core/styles";

const useStyle = makeStyles(theme => ({
    root: {
        width: 200
    }
}))


const YESNO_ITEMS = [
    createSelectItem('yes', Tr('yes')),
    createSelectItem('no', Tr('no')),
]

function OfferYesNoInput(
    {
        id,
        formikProps,
        disabled
    }) {

    const classes = useStyle();

    return (
        <Select
            className={classes.root}
            id={id + ".value"}
            formikProps={formikProps}
            label={Tr('choose_value')}
            items={YESNO_ITEMS}
            disabled={disabled}
        />
    )


}

OfferYesNoInput.propTypes = {
    id: PropTypes.string.isRequired,
    disabled: PropTypes.bool.isRequired
}

export default OfferYesNoInput;